import { Component } from '@angular/core';
export class DeleteIconComponent {static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: 'delete-icon',
    template: `
      <span>
          <svg height="16px" viewBox="0 0 32 32" width="16px">
              <path d="M17.459,16.014l8.239-8.194c0.395-0.391,0.395-1.024,0-1.414c-0.394-0.391-1.034-0.391-1.428,0  l-8.232,8.187L7.73,6.284c-0.394-0.395-1.034-0.395-1.428,0c-0.394,0.396-0.394,1.037,0,1.432l8.302,8.303l-8.332,8.286  c-0.394,0.391-0.394,1.024,0,1.414c0.394,0.391,1.034,0.391,1.428,0l8.325-8.279l8.275,8.276c0.394,0.395,1.034,0.395,1.428,0  c0.394-0.396,0.394-1.037,0-1.432L17.459,16.014z"
                    fill="#121313" />
          </svg>
      </span>
    `,
    styles: [`
      .dark tag:focus {
        -webkit-box-shadow: 0 0 0 1px #323232;
                box-shadow: 0 0 0 1px #323232; }

      .ng2-tag-input.bootstrap3-info {
        background-color: #fff;
        display: inline-block;
        color: #555;
        vertical-align: middle;
        max-width: 100%;
        height: 42px;
        line-height: 44px; }

      .ng2-tag-input.bootstrap3-info input {
        border: none;
        -webkit-box-shadow: none;
                box-shadow: none;
        outline: none;
        background-color: transparent;
        padding: 0 6px;
        margin: 0;
        width: auto;
        max-width: inherit; }

      .ng2-tag-input.bootstrap3-info .form-control input::-moz-placeholder {
        color: #777;
        opacity: 1; }

      .ng2-tag-input.bootstrap3-info .form-control input:-ms-input-placeholder {
        color: #777; }

      .ng2-tag-input.bootstrap3-info .form-control input::-webkit-input-placeholder {
        color: #777; }

      .ng2-tag-input.bootstrap3-info input:focus {
        border: none;
        -webkit-box-shadow: none;
                box-shadow: none; }

      .bootstrap3-info.ng2-tag-input.ng2-tag-input--focused {
        -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.4);
                box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.4);
        border: 1px solid #ccc; }

      .bootstrap3-info.ng2-tag-input.ng2-tag-input--invalid {
        -webkit-box-shadow: inset 0 1px 1px #d9534f;
                box-shadow: inset 0 1px 1px #d9534f; }

      .ng2-tag-input {
        display: block;
        -webkit-box-orient: horizontal;
        -webkit-box-direction: normal;
            -ms-flex-direction: row;
                flex-direction: row;
        -ms-flex-wrap: wrap;
            flex-wrap: wrap;
        position: relative;
        -webkit-transition: all 0.25s;
        transition: all 0.25s;
        padding: 0.25rem 0;
        min-height: 32px;
        cursor: text;
        border-bottom: 2px solid #efefef; }
        .ng2-tag-input:focus {
          outline: 0; }
        .ng2-tag-input.ng2-tag-input--dropping {
          opacity: 0.7; }
        .ng2-tag-input.ng2-tag-input--focused {
          border-bottom: 2px solid #2196F3; }
        .ng2-tag-input.ng2-tag-input--invalid {
          border-bottom: 2px solid #f44336; }
        .ng2-tag-input.ng2-tag-input--loading {
          border: none; }
        .ng2-tag-input.ng2-tag-input--disabled {
          opacity: 0.5;
          cursor: not-allowed; }
        .ng2-tag-input form {
          margin: 0.1em 0; }
        .ng2-tag-input .ng2-tags-container {
          -ms-flex-wrap: wrap;
              flex-wrap: wrap;
          display: -webkit-box;
          display: -ms-flexbox;
          display: flex; }

      .minimal.ng2-tag-input {
        display: block;
        -webkit-box-orient: horizontal;
        -webkit-box-direction: normal;
            -ms-flex-direction: row;
                flex-direction: row;
        -ms-flex-wrap: wrap;
            flex-wrap: wrap;
        position: relative;
        cursor: text;
        border-bottom: 1px solid transparent; }
        .minimal.ng2-tag-input:focus {
          outline: 0; }
        .minimal.ng2-tag-input.ng2-tag-input--dropping {
          opacity: 0.7; }
        .minimal.ng2-tag-input.ng2-tag-input--loading {
          border: none; }
        .minimal.ng2-tag-input.ng2-tag-input--disabled {
          opacity: 0.5;
          cursor: not-allowed; }
        .minimal.ng2-tag-input .ng2-tags-container {
          -ms-flex-wrap: wrap;
              flex-wrap: wrap;
          display: -webkit-box;
          display: -ms-flexbox;
          display: flex; }

      .dark.ng2-tag-input {
        display: block;
        -webkit-box-orient: horizontal;
        -webkit-box-direction: normal;
            -ms-flex-direction: row;
                flex-direction: row;
        -ms-flex-wrap: wrap;
            flex-wrap: wrap;
        position: relative;
        cursor: text;
        border-bottom: 2px solid #444; }
        .dark.ng2-tag-input:focus {
          outline: 0; }
        .dark.ng2-tag-input.ng2-tag-input--dropping {
          opacity: 0.7; }
        .dark.ng2-tag-input.ng2-tag-input--loading {
          border: none; }
        .dark.ng2-tag-input.ng2-tag-input--disabled {
          opacity: 0.5;
          cursor: not-allowed; }
        .dark.ng2-tag-input .ng2-tags-container {
          -ms-flex-wrap: wrap;
              flex-wrap: wrap;
          display: -webkit-box;
          display: -ms-flexbox;
          display: flex; }

      .bootstrap.ng2-tag-input {
        display: block;
        -webkit-box-orient: horizontal;
        -webkit-box-direction: normal;
            -ms-flex-direction: row;
                flex-direction: row;
        -ms-flex-wrap: wrap;
            flex-wrap: wrap;
        position: relative;
        cursor: text;
        border-bottom: 2px solid #efefef; }
        .bootstrap.ng2-tag-input:focus {
          outline: 0; }
        .bootstrap.ng2-tag-input.ng2-tag-input--dropping {
          opacity: 0.7; }
        .bootstrap.ng2-tag-input.ng2-tag-input--focused {
          border-bottom: 2px solid #0275d8; }
        .bootstrap.ng2-tag-input.ng2-tag-input--invalid {
          border-bottom: 2px solid #d9534f; }
        .bootstrap.ng2-tag-input.ng2-tag-input--loading {
          border: none; }
        .bootstrap.ng2-tag-input.ng2-tag-input--disabled {
          opacity: 0.5;
          cursor: not-allowed; }
        .bootstrap.ng2-tag-input .ng2-tags-container {
          -ms-flex-wrap: wrap;
              flex-wrap: wrap;
          display: -webkit-box;
          display: -ms-flexbox;
          display: flex; }

      .bootstrap3-info.ng2-tag-input {
        display: block;
        -webkit-box-orient: horizontal;
        -webkit-box-direction: normal;
            -ms-flex-direction: row;
                flex-direction: row;
        -ms-flex-wrap: wrap;
            flex-wrap: wrap;
        position: relative;
        padding: 4px;
        cursor: text;
        -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
                box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
        border-radius: 4px; }
        .bootstrap3-info.ng2-tag-input:focus {
          outline: 0; }
        .bootstrap3-info.ng2-tag-input.ng2-tag-input--dropping {
          opacity: 0.7; }
        .bootstrap3-info.ng2-tag-input.ng2-tag-input--invalid {
          border-bottom: 1px solid #d9534f; }
        .bootstrap3-info.ng2-tag-input.ng2-tag-input--loading {
          border: none; }
        .bootstrap3-info.ng2-tag-input.ng2-tag-input--disabled {
          opacity: 0.5;
          cursor: not-allowed; }
        .bootstrap3-info.ng2-tag-input form {
          margin: 0.1em 0; }
        .bootstrap3-info.ng2-tag-input .ng2-tags-container {
          -ms-flex-wrap: wrap;
              flex-wrap: wrap;
          display: -webkit-box;
          display: -ms-flexbox;
          display: flex; }

      .error-message {
        font-size: 0.8em;
        color: #f44336;
        margin: 0.5em 0 0 0; }

      .bootstrap .error-message {
        color: #d9534f; }

      :host(delete-icon) {
        width: 20px;
        height: 16px;
        -webkit-transition: all 0.15s;
        transition: all 0.15s;
        display: inline-block;
        text-align: right; }
        :host(delete-icon) path {
          fill: #444; }
        :host(delete-icon) svg {
          vertical-align: bottom;
          height: 34px; }

      :host(delete-icon):hover {
        -webkit-transform: scale(1.5) translateY(-3px);
                transform: scale(1.5) translateY(-3px); }

      :host-context(.dark) {
        text-align: right; }
        :host-context(.dark) path {
          fill: #fff; }
        :host-context(.dark) svg {
          vertical-align: bottom;
          height: 34px; }

      :host-context(.minimal) {
        text-align: right; }
        :host-context(.minimal) path {
          fill: #444; }
        :host-context(.minimal) svg {
          vertical-align: bottom;
          height: 34px; }

      :host-context(.bootstrap) {
        text-align: right; }
        :host-context(.bootstrap) path {
          fill: #fff; }
        :host-context(.bootstrap) svg {
          vertical-align: bottom;
          height: 34px; }

      :host-context(tag:focus) path,
      :host-context(tag:active) path {
        fill: #fff; }

      :host-context(.dark tag:focus) path,
      :host-context(.dark tag:active) path {
        fill: #000; }

      :host-context(.minimal tag:focus) path,
      :host-context(.minimal tag:active) path {
        fill: #000; }

      :host-context(.bootstrap tag:focus) path,
      :host-context(.bootstrap tag:active) path {
        fill: #fff; }

      :host-context(.bootstrap3-info) {
        height: inherit; }
        :host-context(.bootstrap3-info) path {
          fill: #fff; }
    `]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function DeleteIconComponent_tsickle_Closure_declarations() {
/** @type {?} */
DeleteIconComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
DeleteIconComponent.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
